import { render } from "./AnnotationSuggestionCrop.vue?vue&type=template&id=2d114ac2&scoped=true"
import script from "./AnnotationSuggestionCrop.vue?vue&type=script&lang=js"
export * from "./AnnotationSuggestionCrop.vue?vue&type=script&lang=js"

import "./AnnotationSuggestionCrop.vue?vue&type=style&index=0&id=2d114ac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d114ac2"]])

export default __exports__